"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import OperationTypeWidget from "D5Utils/operation_widget/OperationTypeWidget";
import BaseFilterEditor from "D5Utils/filter_editor/BaseFilterEditor";
import { System } from "Constants/objects";

var FormFilterEditor =
/*#__PURE__*/
function (_BaseFilterEditor) {
  _inherits(FormFilterEditor, _BaseFilterEditor);

  /**
   * @var {string} type [number | string | date | select | boolean]
   * @var {string} fieldName
   * @var {string} defOperation ['=' | '<>' | '<' | '<=' | '>' | '>=' | 'contains' | 'between']
   * @var {any} value
   * @var {object} rest
   * {
   *   onOperationChanged: {function},
   *   onValueChanged: {function},
   * }
   *
   *
   */
  function FormFilterEditor(options, props) {
    var _this;

    _classCallCheck(this, FormFilterEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormFilterEditor).call(this, options, props));
    var defOperation = options.defOperation;
    _this._operationWidget = new OperationTypeWidget({
      type: _this._type,
      id: "form-".concat(props._id),
      operation: defOperation,
      subscribers: [_assertThisInitialized(_assertThisInitialized(_this))]
    });
    return _this;
  }
  /**
   * @return {string} [number | numberTwin | text | date | dateTwin | select | multiSelect | bool | boolTable]
   */


  _createClass(FormFilterEditor, [{
    key: "getFieldType",
    value: function getFieldType() {
      if (this._type === System.FIELD_EDITOR_TYPE.BOOL_CB || this._type === System.FIELD_EDITOR_TYPE.SELECT || this._type === System.FIELD_EDITOR_TYPE.MULTI_SELECT) {
        return this._type;
      }

      switch (this.operation()) {
        case '=':
        case '<>':
        case '<':
        case '>':
        case '<=':
        case '>=':
          return this._type;

        case 'contains':
          return System.FIELD_EDITOR_TYPE.TEXT;

        case 'between':
          return this._type === System.FIELD_EDITOR_TYPE.NUMBER ? System.FIELD_EDITOR_TYPE.NUMBER_TWIN : System.FIELD_EDITOR_TYPE.DATE_TWIN;

        case 'isanyof':
        case 'isnotanyof':
          return System.FIELD_EDITOR_TYPE.ANY_OF;

        default:
          return this.operation();
      }
    }
  }]);

  return FormFilterEditor;
}(BaseFilterEditor);

export { FormFilterEditor as default };